export {default as DialogDeleteEntry} from './DialogDeleteEntry';
export * from './DialogDeleteEntry';
